import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import type { OutreachCareerTier } from 'fym-shared/src/music24/outreach/types';
import { TypedMemo } from '../../../common/types';
import { Panel, PanelBody, PanelHead } from '../../components/primitives/Panel';
import { profileMessages as messages } from './profileMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import shared from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */
import styles from './Profile.module.scss';

const TIERS: Array<{ tier: OutreachCareerTier; label: typeof messages.tierEmerging }> = [
  { tier: 'emerging', label: messages.tierEmerging },
  { tier: 'developing', label: messages.tierDeveloping },
  { tier: 'mid', label: messages.tierMid },
  { tier: 'established', label: messages.tierEstablished },
];

/** "Your size" (design outreach b1): the career tier that sets the target sizes. Read only. */
const ProfileSizeCardComponent: React.FC<{ tier: OutreachCareerTier }> = ({ tier }) => {
  const intl = useIntl();
  const steps = useMemo(
    () =>
      TIERS.map((item) => (
        <span
          key={item.tier}
          className={clsx(styles.tierStep, item.tier === tier && styles.tierOn)}
          aria-current={item.tier === tier ? 'true' : undefined}
        >
          {intl.formatMessage(item.label)}
        </span>
      )),
    [intl, tier]
  );
  return (
    <Panel as="section">
      <PanelHead title={intl.formatMessage(messages.sizeTitle)} />
      <PanelBody>
        <div className={shared.stack}>
          <div className={styles.tier}>{steps}</div>
          <p className={shared.small}>{intl.formatMessage(messages.sizeBody)}</p>
        </div>
      </PanelBody>
    </Panel>
  );
};

export const ProfileSizeCard = TypedMemo(ProfileSizeCardComponent);
